<template>
  <div class="country">
    <BreadCrumbs :name="country[this.$route.params.id].breadcrumbName" />
    <div class="items">
      <div
        class="item"
        v-for="(item, key) in country[this.$route.params.id].items"
        :key=key
        @click="showModal(item.value)"
      >
        <div class="header">
          <img :src="item.image">
        </div>
        <div class="body">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-lg"
      size="lg"
      title="Directories"
      :ok-only="true"
    >
      <div class="list">
        <div
          class="list-item"
          v-for="(item, key) in selected"
          :key="key"
        >

          <div class="option">
            <div class="icon">
              <img :src="item.icon">
            </div>
            <span>{{item.name}}</span>
          </div>
          <div class="action">
            <ul>
              <li
                v-for="(option, optionKey) in item.options"
                :key="optionKey"
              ><a
                  :href="option.url"
                  target="_blank"
                >{{option.name}}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BreadCrumbs from "@/components/Breadcrumbs";
export default {
  name: "Country",
  components: {
    BreadCrumbs
  },
  data() {
    return {
      selected: [],
      selectedCountry: [],
      country: {
        do: {
          items: [
            {
              name: "Dominican Fiesta",
              image: "/img/banner_dominican_fiesta.jpg",
              value: "phgsd.dyndns.org"
            },
            {
              name: "Punta Cana",
              image: "/img/banner_punta_cana.jpg",
              value: "phgpc.dyndns.org"
            },
            {
              name: "Capcana",
              image: "/img/banner_trs.jpg",
              value: "phgcc.dyndns.org"
            }
          ],
          breadcrumbName: "Rep. Dominicana"
        },
        mx: {
          items: [
            {
              name: "Costa Mujeres",
              image: "/img/banner_costa_mujeres.png",
              value: "phgcm.dyndns.org"
            },
            {
              name: "Riviera Maya",
              image: "/img/banner_riviera_maya.png",
              value: "phgrm.dyndns.org"
            },
            {
              name: "Puerto Vallarta",
              image: "/img/banner_puerto_vallarta.png",
              value: "phgpv.dyndns.org"
            }
          ],
          breadcrumbName: "Mexíco"
        },
        br: {
          items: [
            {
              name: "Imbassaí",
              image: "/img/banner_brasil.jpg",
              value: "phgbr.dyndns.org"
            }
          ],
          breadcrumbName: "Brasil"
        },
        es: {
          items: [
            {
              name: "Hard Rock Tenerife",
              image: "/img/banner_hard_rock_tenerife.jpg",
              value: "phgten.dyndns.org"
            }
          ],
          breadcrumbName: "España"
        },
        jm: {
          items: [
            {
              name: "Jamaica",
              image: "/img/banner_jamaica.jpg",
              value: "phgjm.dyndns.org"
            }
          ],
          breadcrumbName: "Jamaica"
        }
      },
      directories: {
        "phgcm.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgcm.dyndns.org:8283/wifiman"
              }
            ]
          },
          {
            name: "Portal Grand Palladium",
            icon:
              "https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/51/54/eb/5154eb37-9793-9b6e-5716-229a76894c4c/AppIcon-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-9.png/246x0w.jpg",
            options: [
              {
                name: "View",
                url: "https://phgcm.dyndns.org:8288/"
              },
              {
                name: "Butler",
                url: "https://phgcm.dyndns.org:8288/butler"
              },
              {
                name: "Admin",
                url: "https://phgcm.dyndns.org:8288/admin"
              }
            ]
          },
          {
            name: "Portal TRS Hotels",
            icon:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8ydGMn_lEYp-C0iMvntPIcluEiW-cD-STe_mMT1D76uUWXFo0",
            options: [
              {
                name: "View",
                url: "https://phgcm.dyndns.org:8289/"
              },
              {
                name: "Butler",
                url: "https://phgcm.dyndns.org:8289/butler"
              },
              {
                name: "Admin",
                url: "https://phgcm.dyndns.org:8289/admin"
              }
            ]
          },
          {
            name: "Portal Family Selection",
            icon:
              "https://palladium-phg-prod.s3.amazonaws.com/hotelimages/grand-palladium/family-selection-grand-palladium-costa-mujeres/family-selection/Logo_Family_Selection_CM.jpg",
            options: [
              {
                name: "View",
                url: "https://phgcm.dyndns.org:8290/"
              },
              {
                name: "Butler",
                url: "https://phgcm.dyndns.org:8290/butler"
              },
              {
                name: "Admin",
                url: "https://phgcm.dyndns.org:8290/admin"
              }
            ]
          }
        ],
        "phgrm.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgrm.dyndns.org:8283/wifiman"
              }
            ]
          },
          {
            name: "Portal Grand Palladium",
            icon:
              "https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/51/54/eb/5154eb37-9793-9b6e-5716-229a76894c4c/AppIcon-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-9.png/246x0w.jpg",
            options: [
              {
                name: "View",
                url: "https://phgrm.dyndns.org:8288/"
              },
              {
                name: "Butler",
                url: "https://phgrm.dyndns.org:8288/butler"
              },
              {
                name: "Admin",
                url: "https://phgrm.dyndns.org:8288/admin"
              }
            ]
          },
          {
            name: "Portal TRS Hotels",
            icon:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8ydGMn_lEYp-C0iMvntPIcluEiW-cD-STe_mMT1D76uUWXFo0",
            options: [
              {
                name: "View",
                url: "https://phgrm.dyndns.org:8289/"
              },
              {
                name: "Butler",
                url: "https://phgrm.dyndns.org:8289/butler"
              },
              {
                name: "Admin",
                url: "https://phgrm.dyndns.org:8289/admin"
              }
            ]
          }
        ],
        "phgpv.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgpv.dyndns.org:8283/wifiman"
              }
            ]
          },
          {
            name: "Portal Family Selection",
            icon:
              "https://palladium-phg-prod.s3.amazonaws.com/hotelimages/grand-palladium/family-selection-grand-palladium-costa-mujeres/family-selection/Logo_Family_Selection_CM.jpg",
            options: [
              {
                name: "View",
                url: "https://vallarta.glowicom.com/"
              },
              {
                name: "Butler",
                url: "https://vallarta.glowicom.com/butler"
              },
              {
                name: "Admin",
                url: "https://vallarta.glowicom.com/admin"
              }
            ]
          }
        ],
        "phgpc.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgpc.dyndns.org:8283/wifiman"
              }
            ]
          },
          {
            name: "Portal Grand Palladium",
            icon:
              "https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/51/54/eb/5154eb37-9793-9b6e-5716-229a76894c4c/AppIcon-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-9.png/246x0w.jpg",
            options: [
              {
                name: "View",
                url: "https://phgpc.dyndns.org:8288/"
              },
              {
                name: "Butler",
                url: "https://phgpc.dyndns.org:8288/butler"
              },
              {
                name: "Admin",
                url: "https://phgpc.dyndns.org:8288/admin"
              }
            ]
          },
          {
            name: "Portal TRS Hotels",
            icon:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8ydGMn_lEYp-C0iMvntPIcluEiW-cD-STe_mMT1D76uUWXFo0",
            options: [
              {
                name: "View",
                url: "https://phgpc.dyndns.org:8289/"
              },
              {
                name: "Butler",
                url: "https://phgpc.dyndns.org:8289/butler"
              },
              {
                name: "Admin",
                url: "https://phgpc.dyndns.org:8289/admin"
              }
            ]
          }
        ],
        "phgcc.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgcc.dyndns.org:8283/wifiman"
              }
            ]
          },
         
          {
            name: "Portal TRS Hotels",
            icon:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8ydGMn_lEYp-C0iMvntPIcluEiW-cD-STe_mMT1D76uUWXFo0",
            options: [
              {
                name: "View",
                url: "https://phgcc.dyndns.org:8289/"
              },
              {
                name: "Butler",
                url: "https://phgcc.dyndns.org:8289/butler"
              },
              {
                name: "Admin",
                url: "https://phgcc.dyndns.org:8289/admin"
              }
            ]
          }
        ],
        "phgsd.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgsc.dyndns.org:8283/wifiman"
              }
            ]
          },
        ],
        "phgsd.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgsd.dyndns.org:8283/wifiman"
              }
            ]
          },
        ],
        "phgbr.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgbr.dyndns.org:8283/wifiman"
              }
            ]
          },
        ],
        "phgjm.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgjm.dyndns.org:8283/wifiman"
              }
            ]
          },
        ],
        "phgten.dyndns.org": [
          {
            name: "Wifiman",
            icon:
              "https://housing.umn.edu/sites/housing.umn.edu/files/prep_your_computer.png",
            options: [
              {
                name: "View",
                url: "http://phgten.dyndns.org:8283/wifiman"
              }
            ]
          },
        ]
      }
    };
  },
  methods: {
    showModal(item) {
      this.selected = this.directories[item];
      this.$bvModal.show("modal-lg");
    }
  }
};
</script>

<style scoped>
.country {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  flex-direction: column;
}
.items {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  flex-direction: column;
}
.items .item {
  position: relative;
  width: 100%;
  height: 100px;
  margin-bottom: 30px;
  border: 1px solid #fff;
  box-shadow: 5px 3px 24px -8px #000;
  cursor: pointer;
}
.items .item .header,
.items .item .header img {
  width: 100%;
  height: 100%;
}
.items .item .body {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.items .item .body span {
  display: block;
  padding: 10px 30px 10px 30px;
  color: #000;
  background: #fff;
  font-family: "ImbueFT";
  font-weight: 700;
  line-height: 0.9;
  font-size: 26px;
  letter-spacing: 1.5px;
}
.list {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: column;
}

.list .list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  /* background: #f7f7f7; */
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.list .list-item .option {
  display: flex;
  align-items: center;
}
.list .list-item .option span {
  margin-left: 20px;
  line-height: 0.9;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
.list .list-item .icon {
  width: 50px;
  height: 50px;
}

.list .list-item .icon img {
  width: 100%;
  height: 100%;
}

.list .list-item .action ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  list-style: none;
  margin: 0;
  margin-left: 10px;
}

.list .list-item .action {
  display: flex;
  align-items: center;
  justify-content: center;
}

.list .list-item .action ul li {
  padding-right: 10px;
}
.list .list-item .action ul li a {
  display: block;
  text-decoration: none;
  background: #000;
  padding: 10px 30px 10px 30px;
  color: #fff;
  border-radius: 5px;
}
@media (max-width: 768px) {
  .items {
    width: 100%;
  }
}
</style>
